import __request__ from "routing/request";
export function categories(requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.securityapp/mitre_categories", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
